// Vidéo du hero (placée dans /public). Remplaçable par n'importe quel .mp4.
export const heroVideo = "/ferrari-hero.mp4";
